__webpack_require__.p = "https://static-assets-dev.novoed.com/assets/gold/";